import classNames from 'classnames';
import { FC } from 'react';
import Button from '../Button/Button';
import { ButtonVariants } from '../Button/Button.types';
import Tooltip from '../Tooltip/Tooltip';
import styles from './BundleSummaryBlock.module.css';
import { SummaryBlockProps } from './BundleSummaryBlock.types';

const BundleSummaryBlock: FC<SummaryBlockProps> = ({ blocks, title, className, variant, tooltipText }) => (
  <div className={classNames(styles.container, { [styles.withTooltip]: tooltipText !== undefined })}>
    {title && (
      <div className={classNames(styles.title, { [styles.withTooltip]: tooltipText !== undefined })}>
        {title}
        {tooltipText && <Tooltip content={tooltipText} />}
      </div>
    )}
    <div
      data-testid="SummaryBlock"
      className={classNames(styles.card, {
        [styles.emphasis]: variant !== undefined,
        [styles.withCount]: blocks?.[0]?.count !== undefined,
        [styles[variant!]]: variant !== undefined,
        [className!]: className !== undefined,
        [styles.multiBlock]: blocks.length > 1,
        [styles.withLabel]: blocks?.[0]?.label !== undefined,
      })}
    >
      {blocks.map(({ count, label, buttonText, onButtonClick }) => (
        <div key={label} className={classNames(styles.blockContent)}>
          {count !== undefined && (
            <div className={styles.count} data-testid="summaryBlockCount">
              {count}
            </div>
          )}
          <div className={styles.label}>{label}</div>
          {buttonText && onButtonClick && (
            <Button variant={ButtonVariants.Text} onClick={onButtonClick}>
              {buttonText}
            </Button>
          )}
        </div>
      ))}
      {blocks.length === 0 && (
        <div className={styles.noBlocksMessage}>Try adding a Block to the &quot;blocks&quot; prop</div>
      )}
    </div>
  </div>
);

export default BundleSummaryBlock;
